// tiptap-extensions.js
import Code from '@tiptap/extension-code'
import Document from '@tiptap/extension-document'
import Link from '@tiptap/extension-link'
import Paragraph from '@tiptap/extension-paragraph'
import Text from '@tiptap/extension-text'
import Image from '@tiptap/extension-image'
import Math from './extension-math'
import InlineMath from './extension-inline-math'
import StarterKit from '@tiptap/starter-kit'
import TextStyle from '@tiptap/extension-text-style'
import Color from '@tiptap/extension-color'
import Underline from '@tiptap/extension-underline'
import TextAlign from '@tiptap/extension-text-align'
import { ExtensionImage } from './extension-image'

export const getTiptapExtensions = () => [
    StarterKit, 
    Color, 
    Underline, 
    TextAlign.configure({
      types: ['heading', 'paragraph'],
    }),
    TextStyle, 
    Math,
    InlineMath,
    Document, 
    Paragraph, 
    Text, 
    Code, 
    Link.configure({
      openOnClick: false,
      autolink: true,
      defaultProtocol: 'https',
    }),
    ExtensionImage.configure({
    inline: true,
    allowBase64: false,
    HTMLAttributes: {
      class: 'resizable-image',
      loading: 'lazy'
    },
  })
]
